import { Injectable } from '@angular/core'
import { FormGroup } from '@angular/forms'

import { Observable, filter, map } from 'rxjs'

@Injectable({
  providedIn: 'root',
})
export class GbFormService {
  syncFormWithState<T>(form: FormGroup, state$: Observable<T | undefined | null>): Observable<void> {
    return state$.pipe(
      filter((state) => !!state),
      map((state) => {
        this.patchValues(state as T, form)
      }),
    )
  }

  patchValues<T>(entity: T, form: FormGroup): void {
    let key: keyof typeof form.value

    for (key in form.value) {
      const patchObject: any = {}
      const entityToPatch = entity as T
      const value = entityToPatch[key as keyof T]
      patchObject[key] = value

      form.patchValue(patchObject)
    }
  }
}
